import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M10.004 9.74c.362 0 .671-.13.928-.387.258-.257.386-.567.386-.928 0-.361-.129-.67-.388-.928a1.274 1.274 0 0 0-.932-.386c-.363 0-.672.13-.926.388-.255.258-.382.57-.382.932 0 .363.129.672.386.927.258.254.567.381.928.381ZM10 16.358c1.545-1.363 2.768-2.743 3.667-4.14.9-1.397 1.35-2.605 1.35-3.624 0-1.509-.476-2.755-1.427-3.737-.95-.983-2.148-1.474-3.591-1.474-1.444 0-2.64.49-3.59 1.474-.95.982-1.425 2.228-1.425 3.737 0 1.019.45 2.227 1.35 3.624.899 1.398 2.121 2.777 3.666 4.14Zm0 1.029c-1.922-1.722-3.367-3.317-4.334-4.785-.968-1.467-1.451-2.802-1.451-4.004 0-1.723.561-3.148 1.685-4.276C7.023 3.194 8.39 2.63 10 2.63c1.61 0 2.978.564 4.1 1.693 1.124 1.128 1.685 2.553 1.685 4.276 0 1.202-.483 2.537-1.45 4.005-.968 1.467-2.412 3.062-4.335 4.784Z"
    />
  </Svg>
)
export default SvgComponent
